import React, { Component } from 'react'
import PropTypes from 'prop-types'
import actions from 'redux/actions'
import { constants } from 'common/helpers'
import { FormattedHTMLMessage } from 'sb-react-intl'

import Modal from 'components/modal/Modal/Modal'
import Button from 'components/buttons/Button/Button'
import CvcHelpContent from 'components/_new/payment/cvcHelp/CvcHelpContent/CvcHelpContent'

import messages from './messages'
import s from './ErrorCVVModal.scss'


class ErrorCVVModal extends Component {

  static propTypes = {
    name: PropTypes.string,
  }

  static defaultProps = {
    name: constants.modals.ErrorCVV,
  }

  handleClose = () => {
    const { name, onClose } = this.props

    actions.models.modals.close(name)

    if (typeof onClose === 'function') {
      onClose()
    }
  }

  render() {
    const { name } = this.props

    return (
      <Modal
        className={s.errorCVVModal}
        name={name}
        title={messages.title}
        onClose={this.handleClose}
        titleUppercase
      >
        <div className={s.text}>
          <FormattedHTMLMessage className={s.description} tag="div" {...messages.title} />
          <FormattedHTMLMessage className={s.description} tag="div" {...messages.description} />
          <Button
            className={s.button}
            brand
            md
            title={messages.buttonTitle}
            onClick={this.handleClose}
          />
        </div>
        <CvcHelpContent className={s.cardHelp} />
      </Modal>
    )
  }
}


export default ErrorCVVModal
